import LivabilityMapContent from './LivabilityMapContent'
import LivabilityMapController from './LivabilityMapContent/LivabilityMapController'

export { default } from './Livability'

export const LivabilityMapConfig = {
  Controller: LivabilityMapController,
  Content: LivabilityMapContent,
}
